require( 'owl.carousel' );

import nav from './modules/nav';
import products from './modules/products';
import photos from './modules/photos';
import videos from './modules/videos';
import about from './modules/about';
import music from './modules/music';

jQuery( document ).ready(function($) {

  // init nav
  nav();

  // init videos
  about();

  // init music
  music();

  // init merch
  products();

  // init photos
  photos();

  // init videos
  videos();
    
});
